import React from "react";

import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import LocalizationSwitcher from "@components/localizationSwitcher/LocalizationSwitcher";

import "./EntryPage.scss";

/**
 * EntryPageView component renders the entry page for users who are not logged in.
 *
 * @param {Object} props - The properties object.
 * @param {Function} props.onLocalizationChangeLang - Function to handle language change.
 * @param {import("react").MouseEventHandler} props.onEntryPageStudentBtnClick - Function to handle click on the student button.
 * @param {import("react").MouseEventHandler} props.onNotLoggedCompanySpanClick - Function to handle click on the company span.
 *
 * @returns {JSX.Element} The rendered EntryPageView component.
 */
function EntryPageView(props) {
    const [t] = useTranslation();

    return (
        <div className="entryPage">
            <div className="entryPage-wrapper-left">
                <div className="content-wrapper">
                    <div className="language-selector-wrapper">
                        <div className="language-selector">
                            <LocalizationSwitcher changeLang={props.onLocalizationChangeLang} />
                        </div>
                    </div>
                    <div className="content">
                        <div className="iddink-logo">
                            <img src="/InleverBlueIcon.svg" alt="image" />
                            <img src="/InleverBlueLogo.svg" alt="image" />
                        </div>
                        <div className="content-title">
                            <span className="content-title-1">{t("NotLoggedTitle")}</span>
                            <span className="content-title-2">{t("NotLoggedSubtitle")}</span>
                        </div>
                        <span className="content-description">{t("EntryPageDescription")}</span>
                        <div className="content-buttons mt-5">
                            <Button className="content-buttons-button" onClick={props.onEntryPageStudentBtnClick}>
                                {t("EntryPageStudentBtn")}
                            </Button>
                            {/* <span>{t("Or")}</span>
                  <Button
                    className="content-buttons-button"
                    onClick={() => {
                      navigate(WebRoutes.UserLoginPage);
                    }}
                  >
                    {t("EntryPageAdminBtn")}
                  </Button>
                  <Button
                    className="content-buttons-button"
                    onClick={() => {
                      // navigate(WebRoutes.UserLoginPage);
                      redirectExternal();
                    }}
                  >
                    {t("School account")}
                  </Button> */}
                        </div>
                    </div>
                    <span onClick={props.onNotLoggedCompanySpanClick}>{t("NotLoggedCompany")}</span>
                </div>
            </div>
            <div className="entryPage-wrapper-right" />
        </div>
    );
}

export default EntryPageView;
